import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  TextField,
} from '@mui/material';
import { Controller, Form } from 'react-hook-form';
import { isNil, startCase } from 'lodash';
import useBeds from '@views/pages/Admin/Buildings/components/BuildingItem/hooks/useBeds.ts';
import { paths } from '@types';
import { BED_UNITS, BedUnits } from '@common/types';
import { t } from 'i18next';
import { SaveChangesModal } from '@components';

interface IBedsProps {
  building: paths[`/building/{record_id}`]['get']['responses']['200']['content']['application/json'];
}

const Beds = ({ building }: IBedsProps) => {
  const {
    control,
    onSubmit,
    isSubmitting,
    isSubmitEnabled,
    isSaveChangesModalOpen,
    handleCloseSaveChangesModal,
    handleDiscardChanges,
    handleSaveChanges,
    isValid,
    isEditSubmitting,
  } = useBeds(building);

  return (
    <Form
      control={control}
      onSubmit={e => onSubmit(e.event)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      {BED_UNITS.map((key, index) => (
        <Box
          key={`${key}-${index}`}
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            borderRadius: '4px',
          }}
        >
          <Controller
            name={key as BedUnits}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth>
                <TextField
                  {...field}
                  label={startCase(key.split('_').join(' '))}
                  variant='outlined'
                  error={!isNil(error)}
                  type='number'
                  onChange={event => {
                    if (
                      event.target.value === '' ||
                      Number(event.target.value) >= 0
                    ) {
                      field.onChange(event);
                    }
                  }}
                  fullWidth
                  required
                />
                <FormHelperText error={!isNil(error)}>
                  {error ? error.message : null}
                </FormHelperText>
              </FormControl>
            )}
          />
        </Box>
      ))}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          pt: '0.5rem',
          position: 'sticky',
          bottom: '0',
          left: 0,
          bgcolor: theme => theme.palette.common.white,
          zIndex: 10,
        }}
      >
        <Button
          type='submit'
          variant='contained'
          color='secondary'
          sx={{
            fontSize: '0,875rem',
            fontWeight: 'medium',
            lineHeight: '24px',
            color: 'white',
          }}
          disabled={!isSubmitEnabled}
          loading={isSubmitting}
          loadingPosition='center'
        >
          {t('general.saveChanges')}
        </Button>
      </Box>
      <SaveChangesModal
        isOpen={isSaveChangesModalOpen}
        onClose={handleCloseSaveChangesModal}
        isValid={isValid}
        handleSaveChanges={handleSaveChanges}
        discardChanges={handleDiscardChanges}
        isLoading={isEditSubmitting}
      />
    </Form>
  );
};

export default Beds;
